module.exports = __webpack_public_path__ + "img/align-center.e0cd2745.svg";